__turbopack_context__.v({
  "details": "DmUtga_details",
  "empty": "DmUtga_empty",
  "header": "DmUtga_header",
});
